<template>
	<div class="loading-icon"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
</template>

<script>
export default {
    name: 'LoadingIcon',
}
</script>
